import React, { useState, useMemo, useRef } from "react";
import { Dropdown, FormControl } from "react-bootstrap";
import { FaSearch, FaTimes, FaChevronDown,FaCheck } from "react-icons/fa";
const GlobalSearchableDropdown = ({
  isClearable=true,
  options = [],
  selected,
  onSelect,
  placeholder = "Select",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef();
  const filteredOptions = useMemo(() => {
    return options.filter((item) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [options, searchTerm]);
  const handleToggle = (isOpen) => {
    if (isOpen) {
      setTimeout(() => {
        setSearchTerm(""); // Clear input on open
        searchInputRef.current?.focus(); // Auto-focus
      }, 0);
    }
  };
  return (
    <Dropdown onToggle={handleToggle}>
      <Dropdown.Toggle
        as="span"
        className="custom-toggle d-flex justify-content-between align-items-center"
      >
        <span>{selected ? selected.label : placeholder}</span>
        {selected&&isClearable&& (
          <FaTimes
            size={11}
            className="ms-2 clear-icon"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(null);
              setSearchTerm("");
            }}
            style={{ cursor: "pointer" }}
          />
        )}

        <FaChevronDown size={11} className="ms-2 dropdown-arrow" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="custom-dropdown-menu p-2">
        <div className="d-flex align-items-center position-relative">
          <span className="position-absolute ms-2 text-dark">
            <FaSearch size={14} />
          </span>
          <input
            type="search"
            ref={searchInputRef}
            placeholder="Search..."
            value={searchTerm}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control rounded-2 small-search-input border-2"
            style={{ paddingLeft: "35px" }}
          />
        </div>
        <div
          className="p-1 mt-1 d-flex justify-content-between"
          style={{ fontSize: "0.7rem" }}
        >
          <div>
            <span className="text-dark fw-medium">{placeholder || "-"}</span>
          </div>
          <div>
            <span className="text-dark fw-medium">Total </span>
            <span
              className="text-darker fw-medium"
              style={{ fontSize: "0.6rem" }}
            >{`(${options?.length || 0})`}</span>
          </div>
        </div>

        <div className="scrollable-option">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, idx) => {
              const isActive = selected?.value === item.value;
              return (
                <Dropdown.Item
                  key={idx}
                  className={`custom-dropdown-item ${isActive ? "active" : ""}`}
                  onClick={() => {
                    onSelect(item);
                    setSearchTerm("");
                  }}
                >
                  <span className="flex-grow-1 me-2">{item.label}</span>
                  {isActive && <FaCheck className="text-success" size={12} />}
                </Dropdown.Item>
              );
            })
          ) : (
            <div className="px-3 text-dark text-center">No options found</div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default GlobalSearchableDropdown;
